export default "__VITE_ASSET__H0fSw1PY__"